///<reference path="../../App/plugins/DefinitelyTyped/toastr.d.ts"/>
import {Injectable}  from '@angular/core';
import {HTTPService} from '../Services/http.service';
import { Observable }   from 'rxjs/Observable';

@Injectable()
export class MySharedService {
    data = "";
    constructor(private _httpService: HTTPService) {
        this.data = "hello";
         toastr.options = {  "closeButton": true,positionClass: 'toast-bottom-right' } 
    }

  GetParameter(paramval): Observable<any[]> {
         return this._httpService.ajaxPost('common/GetParameter',{"ParameterTypeId":paramval});
     }  
  
  
  public ShowMessage(statusMessage: any){
      var message=statusMessage.split('|');
      switch(message[0].toLowerCase())
      {
         case "info":
         toastr.info( message[1]);
         break;
         case "success":
         toastr.success( message[1]);
         break;
         case "warning":
         toastr.warning( message[1]);
         break;
         case "error":
         toastr.error( message[1]);
         break;
         default:
         toastr.info( message[1]);
         break;
      }     
  }

  public stringToColumns(strInput : any)
  {
      var replacement_for_comma = "@|@";
      var replacement_for_doublequote = "";
      var replacement_for_column = "$|$";
      var strOutput = this.identifyQuotedString(strInput,replacement_for_comma,replacement_for_doublequote);
      strOutput = strOutput.split(",").join(replacement_for_column);
      strOutput = strOutput.split(replacement_for_comma).join(",");
      return strOutput.split(replacement_for_column);
  }
  public identifyQuotedString(strInput : any,replacement_for_comma:any,replacement_for_doublequote:any)
  {
      // split content based on comma

            if( strInput.indexOf('"') >= 0 )
            {
                var first_double_quote = strInput.indexOf('"');
                var second_double_quote = strInput.indexOf('"',first_double_quote + 1);
                var temp_str = strInput.substring(first_double_quote, second_double_quote + 1);
                if( temp_str.indexOf(',') >= 0 )
                {
                    var new_str = temp_str.split(",").join(replacement_for_comma);
                    new_str = new_str.split('"').join(replacement_for_doublequote);
                    strInput = strInput.replace(temp_str, new_str);
                }

                strInput = this.identifyQuotedString(strInput,replacement_for_comma,replacement_for_doublequote);
            }
            return strInput;
  }
  
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/App/shared.service.ts
 **/